import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map, first } from 'rxjs/operators';
import { ACResourceService } from '@appcatalyst/ng-cms-core-lib';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  private contacts = new ReplaySubject<any>(1);
  private contactsPicker = new ReplaySubject<any>(1);

  constructor(private cms: ACResourceService) { }

  public updateContacts = (params: any) => {
    var path = `/contacts`
    return this.cms.request('GET', path, params).pipe(
      first(),
      map(data => {
        this.contacts.next(data)
        return data
      })
    )
  }

  public getContacts = (): Observable<any> => {
    return this.contacts.asObservable()
  }

  public updateContactsPicker = () => {
    var path = `contacts`
    return this.cms.request('GET', path).pipe(
      first(),
      map(data => {
        this.contactsPicker.next(data)
        return data
      })
    )
  }

  public getContactsPicker = (): Observable<any> => {
    return this.contactsPicker.asObservable()
  }

}
